import { useContext } from "react";
import { CreateActionContext } from "./CreateActionContext";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";

function useInitialize() {
  const { setElement, setShowModal } = useContext(CreateActionContext);
  const { setChanged } = useContext(ChangeDectionContext);
  return (initializeData: any = {}) => {
    setElement(initializeData);
    setTimeout(() => {
      setShowModal(true);
      setChanged(false, initializeData);
    }, 500);
  };
}

export default useInitialize;
